import React from 'react';
import styled from 'libs/styled';
import type { ConfiguratorModule as ConfiguratorModuleData } from 'libs/sanity/types/generated';
import ConfiguratorBlock from 'libs/sanity/content/Blocks/ConfiguratorBlock';

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
`;

interface ConfiguratorModuleProps {
    data?: ConfiguratorModuleData;
}

const ConfiguratorModule: React.FC<ConfiguratorModuleProps> = () => (
    <ModuleWrapper>
        <ConfiguratorBlock />
    </ModuleWrapper>
);

export default ConfiguratorModule;
